<template>
  <div class="entity">
    <header>选择产品</header>
    <article>
      <div class="box-1">
        <label for="isMasterCard" class="label">类型</label>
        <div :class="checkIndex === 0 ? 'checked' : 'unchecked'" @click="checkIndex = 0">
          <div class="inside"></div>
        </div>
        <div class="flexaj master-logo" @click="checkIndex = 0">
          <img src="@/assets/master_logo.jpg" alt />
        </div>
        <div :class="checkIndex === 1 ? 'checked' : 'unchecked'" @click="checkIndex = 1" style="margin-left: 20px;">
          <div class="inside"></div>
        </div>
        <div class="flexaj master-logo" @click="checkIndex = 1">
          <img src="@/assets/unionpayLogo.png" alt width="50" height="30" />
        </div>
      </div>

      <div class="box-2 flexa">
        <label for="isMasterCard" class="label">币种</label>
        <div class="flexa inside-box" v-for="n in 3" :key="n" @click="handleCurrencyChange(n)">
          <div class="checked" v-if="currency == n">
            <div class="inside"></div>
          </div>
          <div class="unchecked" v-else @click="currency = n"></div>
          <label for="HKD" class="currency">{{ n === 1 ? "人民幣" : n === 2 ? "港幣" : "美元" }}</label>
        </div>
      </div>

      <div class="flex denomination">
        <label for="denomination" class="label">面额</label>
        <div class="flex d-list">
          <div class="d-item flexa" v-for="(item, index) of dList" :key="index">
            <img src="@/assets/checked.gif" width="20" height="20" v-if="item.count" />
            <img src="@/assets/uncheck.gif" width="20" height="20" v-else />
            <el-input class="money-input" :class="item.count ? 'active' : ''" style="width: 160px" :value="getCurrency + ' ' + item.denomination" :disabled="true"></el-input>
            <!-- <span class="p-f16" style="margin-left: 12px;">{{item.denomination}}</span> -->
            <span class="p-999" style="margin-left: 12px">X</span>
            <el-input placeholder="卡數量" :class="item.count ? 'active2' : ''" style="width: 100px; margin-left: 12px" maxlength="4" v-model="item.count" @input="calTop(item)"></el-input>
            <span style="margin-left: 12px; color: #c0c4d6">張</span>
          </div>
        </div>
      </div>
      <div class="diyDenomination" style="margin-top: 8px">
        <label for="denomination" class="label"></label>
        <div class="d-list">
          <div class="flexa d-item" v-for="(item, index) of diyList" :key="index">
            <img src="@/assets/checked.gif" width="20" height="20" v-if="item.diyCount && item.diyMoney" />
            <img src="@/assets/uncheck.gif" width="20" height="20" v-else />
            <el-input
              class="change-placeholder"
              :class="item.diyMoney ? 'active' : ''"
              :placeholder="getPlaceHolder"
              v-model="item.diyMoney"
              @blur="validateDiyMoney(item)"
              maxlength="7"
              style="width: 160px"
            ></el-input>
            <span class="p-999" style="margin-left: 12px">X</span>
            <el-input
              :class="item.diyCount ? 'active2' : ''"
              placeholder="卡数量"
              v-model="item.diyCount"
              style="width: 100px; margin-left: 12px"
              @blur="validateDiyAccount(item)"
              maxlength="4"
            ></el-input>
            <span style="margin-left: 8px; color: #c0c4d6">張</span>
            <span class="minus" @click="deleteDenomination(index)" v-if="index !== diyList.length - 1">-</span>
            <span class="add" @click="addDenomination" v-if="index === diyList.length - 1">+</span>
          </div>
        </div>
      </div>
      <!-- <div class="tips">
        <label for class="label"></label>
        <span>（{{getCurrency}}：{{minAmount}}-{{maxAmount}}，{{currency===amountList.length?'10':'100'}}的倍数）</span>
      </div>-->
      <div class="box-4">
        <div class="flexa">
          <label for="sum" class="label">合計</label>
          <div class="flexa">
            <span class="p-fw">{{ getSumOfCount }}</span>
            <span style="margin-left: 4px">张</span>
          </div>
          <div class="flex">
            <span class="p-f16" style="margin-left: 10px">{{ getCurrency }}</span>
            <span class="sum">{{ getSum }}</span>
          </div>
        </div>
        <div class="box-4-tips">單筆超過{{ getCurrency }}{{ maxSum }},需攜帶身份證件親臨本公司香港辦公地點購買! 查詢: Business@epaylinks.hk</div>
      </div>
      <div class="flexa" style="margin-bottom: 20px">
        <label for="useFor" class="label">購卡用途</label>
        <div class="flexa" style="margin-right: 40px; cursor: pointer" v-for="n in 2" :key="n" @click="handleUsageChange(n)">
          <div class="checked" v-if="usage == n">
            <div class="inside"></div>
          </div>
          <div class="unchecked" v-else @click="usage = n"></div>
          <label style="margin-left: 8px; cursor: pointer">{{ n === 1 ? "自用 Personal Use" : "送禮 Gift" }}</label>
        </div>
      </div>
      <div class="flexa">
        <label for="email" class="label">登記電郵</label>
        <el-input v-model="email" style="width: 300px"></el-input>
        <div class="tips" style="margin-left: 12px">請確保電郵有效，如收不到可能為郵箱誤判，請檢查[ 垃圾郵件夾 SPAM box ]</div>
      </div>

      <div class="flexa">
        <label for="mobile" class="label">手机号码</label>
        <div class="flexa">
          <el-select v-model="mobileCodeSelected" placeholder="请选择">
            <el-option v-for="item in mobileCode" :key="item.value" :label="item.code + '  ' + item.area" :value="item.code"></el-option>
          </el-select>
          <el-input v-model="mobile" style="width: 200px; margin-left: 10px" maxlength="11"></el-input>
        </div>
      </div>
      <div class="flexa">
        <label for="captcha" class="label">手機驗證碼</label>
        <div class="flexa">
          <el-input v-model="captcha" style="width: 100px" maxlength="6"></el-input>
          <div class="getSMSCode" @click="getSMSCode" v-if="!isCounting">獲取驗證碼</div>
          <div class="p-999" style="margin-left: 16px" v-else>{{ count }}s後重新獲取</div>
        </div>
      </div>
      <div class="flexa">
        <label for class="label"></label>
        <div>
          <el-checkbox v-model="isAgree">
            <!-- <span style="color: #999;"></span> -->
            <a href="http://globalcash.cn/foot_giftCard.html" target="_blank" style="color: #c0c4d6; font-size: 14px">本人已閱讀並同意遵守禮品卡條款及細則</a>
          </el-checkbox>
        </div>
      </div>
      <el-button type="primary" class="p-fw flexaj" style="width: 160px; margin-left: 106px" @click="order" :loading="isLoading">{{ isLoading ? "加载中" : "下一步" }}</el-button>
    </article>
  </div>
</template>

<script>
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { sumOfAmount, sumOfCount, isNumberBy100, isNumberBy10 } from "@/utils/fun";
import region from "../assets/region.json";
import { mobileCode } from "../assets/mobileCode.json";

import { validateMixins } from "./mixins/validate.js";
export default {
  mixins: [validateMixins],
  methods: {
    async order() {
      this.cardList = [];
      let currency = this.currency === 1 ? "CNY" : this.currency === 2 ? "HKD" : "USD";
      //验证
      if (this.getSum == 0 || this.getSumOfCount == 0) {
        this.$notify({
          title: "警告",
          message: "請填寫面額",
          type: "error"
        });
        return false;
      }
      if (this.currency === 3) {
        if (
          !this.diyList.some((e) => {
            return isNumberBy10(e.diyMoney);
          })
        ) {
          this.$notify({
            title: "警告",
            message: "自定义金额必须是10的整数",
            type: "error"
          });
          return false;
        }
      } else {
        if (
          !this.diyList.some((e) => {
            return isNumberBy100(e.diyMoney);
          })
        ) {
          this.$notify({
            title: "警告",
            message: "自定义金额必须是100的整数",
            type: "error"
          });
          return false;
        }
      }
      if (!this.usage) {
        this.$notify({
          title: "警告",
          message: "請填寫购物网站",
          type: "error"
        });
        return false;
      }
      let emailReg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!this.email) {
        this.$notify({
          title: "警告",
          message: "請填寫郵箱",
          type: "error"
        });
        return false;
      } else if (!emailReg.test(this.email)) {
        this.$notify({
          title: "警告",
          message: "郵箱格式不正確",
          type: "error"
        });
        return false;
      }
      if (!this.mobileCodeSelected) {
        this.$notify({
          title: "警告",
          message: "請選擇區號",
          type: "error"
        });
        return false;
      }
      if (!this.mobile) {
        this.$notify({
          title: "警告",
          message: "請填寫手機號碼",
          type: "error"
        });
        return false;
      }
      if (!this.captcha) {
        this.$notify({
          title: "警告",
          message: "請填寫驗證碼",
          type: "error"
        });
        return false;
      }
      if (!this.isAgree) {
        this.$notify({
          title: "警告",
          message: "請仔細閱讀並同意遵守禮品卡條款及細則",
          type: "error"
        });
        return false;
      }
      this.dList.forEach((e) => {
        let temp = {
          amount: "",
          count: ""
        };
        if (e.count) {
          temp.amount = e.denomination;
          temp.count = e.count;
          this.cardList.push(temp);
        }
      });
      this.diyList.forEach((e) => {
        let temp = {
          amount: "",
          count: ""
        };
        if (e.diyMoney && e.diyCount) {
          temp.amount = e.diyMoney;
          temp.count = e.diyCount;
          this.cardList.push(temp);
        }
      });
      let params = {
        card_organ: this.checkIndex === 0 ? "00" : "01",
        card_type: "01",
        card_currency: currency,
        card_list: this.cardList,
        card_usage: this.usage === 1 ? "自用 Personal Use" : "送禮 Gift",
        apply_mob_country: this.mobileCodeSelected,
        apply_mob_no: this.mobile,
        apply_email: this.email,
        verify_code: this.captcha
      };
      sessionStorage.setItem("params", JSON.stringify(params));
      sessionStorage.setItem("dList", JSON.stringify(this.dList));
      sessionStorage.setItem("diyList", JSON.stringify(this.diyList));
      this.$router.push({
        name: "confirm",
        params: {
          params: Object.assign(params, {
            card_num: sumOfCount(this.cardList)
          }),
          type: "virtual"
        }
      });
    },
    //选择框面额
    moneyChange(e) {
      // this.calculateSum();
      if (Number(e) > this.maxAmount || Number(e) < this.minAmount) {
        this.$notify({
          title: "錯誤",
          message: `自定義金額範圍於${this.minAmount}-${this.maxAmount}`,
          type: "error"
        });
      }
    },
    handleCurrencyChange(index) {
      this.currency = index;
      sessionStorage.setItem("currency", this.currency);
      this.getAmountRange();
    }
  },
  computed: {
    getPlaceHolder() {
      const times = this.currency === 3 ? "10" : "100";
      return `${this.minAmount}-${this.maxAmount} ${times}的倍數`;
    },
    getCurrency() {
      return this.currency === 1 ? "CNY" : this.currency === 2 ? "HKD" : "USD";
    }
  },
  mounted() {
    this.isLoading = false;
    this.mobileCode = mobileCode;
    this.region = region;
    this.currency = Number(sessionStorage.getItem("currency")) || 1;
    this.getAmountChange();
    if (!Object.keys(this.$route.params).length == 0) {
      let params = this.$route.params;
      this.email = params.apply_email;
      this.mobile = params.apply_mob_no;
      this.name = params.apply_name;
      this.mobileCodeSelected = params.apply_mob_country;
      this.sex = params.apply_sex;
      this.cardList = params.card_list;
      this.usage = params.card_usage === "自用 Personal Use" ? 1 : 2;
      this.isAgree = true;
      this.checkIndex = params.card_organ === '00' ? 0 : 1
      let dList = JSON.parse(sessionStorage.getItem("dList"));
      let diyList = JSON.parse(sessionStorage.getItem("diyList"));
      if (dList) {
        this.dList = dList;
        this.calTop();
      }
      if (diyList) {
        this.diyList = diyList;
        this.calBottom();
      }
    }
    sessionStorage.clear();
  }
};
</script>

<style lang="scss">
.active {
  .el-input__inner {
    font-weight: bold;
    color: #389aff !important;
    background-color: #fff !important;
    border-color: #389aff !important;
  }
}
.active2 {
  .el-input__inner {
    font-weight: bold;
    color: #333 !important;
    background-color: #fff !important;
    border-color: #389aff !important;
  }
}
</style>

<style lang="scss" scoped>
.entity {
  width: 960px;
  margin: 0 auto;
  padding-top: 40px;
  .tips {
    color: #a5a9b9;
  }
  header {
    font-size: 18px;
    padding-bottom: 10px;
    color: #333;
  }
  article {
    border-radius: 2px;
    border: 1px solid #ccc;
    padding: 34px 40px 50px;
    margin-bottom: 50px;

    .diyDenomination {
      display: flex;
      margin-bottom: 0;
      .change-placeholder {
        margin-left: 12px;
        /deep/ input::-webkit-input-placeholder {
          font-size: 12px;
        }
      }
      .d-list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .d-item {
          width: 50%;
          /* flex: 0 1 38%; */
          margin-bottom: 16px;
          /* margin-right: 48px; */
        }
      }
      .minus {
        display: inline-flex;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        width: 24px;
        line-height: 24px;
        color: red;
        border: 2px solid red;
        margin-left: 16px;
        border-radius: 4px;
        cursor: pointer;
      }
      .add {
        display: inline-flex;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        width: 24px;
        line-height: 24px;
        color: #409eff;
        border: 2px solid #409eff;
        margin-left: 16px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .denomination {
      display: flex;
      margin-bottom: 0;
      box-sizing: border-box;
      .d-list {
        display: flex;
        flex-wrap: wrap;
        border-bottom: 1px dashed #ccc;
        width: 100%;
        /deep/ .money-input {
          margin-left: 12px;
        }
        .d-item {
          width: 50%;
          /* flex: 0 1 40%; */
          margin-bottom: 12px;
        }
      }
      .tips {
        color: #a5a9b9;
        font-size: 12px;
      }
      .denomination-list {
        display: flex;
        flex-wrap: wrap;
        width: 800px;

        .denomination-item {
          margin-right: 20px;
          width: 44%;
          /* flex: 0 1 44%; */
          box-sizing: border-box;
          margin-bottom: 4px;
        }
      }
      .add {
        display: inline-flex;
        justify-content: center;
        font-size: 16px;
        font-weight: bold;
        width: 24px;
        line-height: 24px;
        color: #409eff;
        border: 2px solid #409eff;
        margin-left: 16px;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .label {
      display: inline-flex;
      width: 60px;
      justify-content: flex-end;
      margin-right: 40px;
      flex-shrink: 0;
    }

    .checked {
      border: 1px solid #409eff;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .inside {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #409eff;
      }
    }
    .unchecked {
      width: 16px;
      height: 16px;
      border: 1px solid #ccc;
      border-radius: 50%;
      cursor: pointer;
    }
    .box-1 {
      display: flex;
      align-items: center;
      .master-logo {
        margin-left: 10px;
        padding: 4px 10px;
        border: 1px solid #ccc;
        border-radius: 4px;
        cursor: pointer;
      }
    }
    .box-2 {
      .inside-box {
        cursor: pointer;
        margin-right: 20px;
      }
      .currency {
        cursor: pointer;
        margin-left: 4px;
        font-size: 14px;
      }
    }
    .box-4 {
      .sum {
        padding-left: 10px;
        font-size: 18px;
        color: #f99f1b;
        font-weight: bold;
      }
    }
    .box-4-tips {
      margin-left: 100px;
      color: #a5a9b9;
      margin-bottom: 20px;
    }
    .userFor {
      height: 40px;
    }
    .getSMSCode {
      padding: 6px 10px;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-left: 10px;
      cursor: pointer;
    }

    .next-step {
      width: 100px;
      line-height: 36px;
      background: url("../assets/images/btn.gif") 0 0 no-repeat;
      font-size: 14px;
      color: #fff;
      font-weight: bold;
      margin: 20px;
      margin-left: 70px;
      cursor: pointer;
    }
    .next-step:hover {
      background: url("../assets/images/btn.gif") 0 -36px no-repeat;
    }
  }
  article > div {
    margin-bottom: 20px;
  }
}
</style>
